import { Activity, Layers, Settings } from "lucide-react";

export type TabId = "runtime" | "templates" | "dataview";

interface MainTabsProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
}

const TABS: Array<{
  id: TabId;
  label: string;
  icon: typeof Activity;
  shortcut: string;
}> = [
  { id: "runtime", label: "Runtime", icon: Activity, shortcut: "R" },
  { id: "templates", label: "Templates", icon: Layers, shortcut: "T" },
  { id: "dataview", label: "数据视图", icon: Settings, shortcut: "D" },
];

export function MainTabs({ activeTab, onTabChange }: MainTabsProps) {
  return (
    <div className="flex h-10 items-center gap-1 border-b border-[var(--border)] bg-[#0c0f14] px-4">
      {TABS.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;

        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex h-8 items-center gap-2 rounded-md px-3 text-xs transition-colors ${
              isActive
                ? "bg-[#1a1e25] text-slate-100"
                : "text-[var(--muted)] hover:bg-white/5 hover:text-slate-200"
            }`}
            type="button"
          >
            <Icon className="size-3.5" />
            <span>{tab.label}</span>
            <kbd className="ml-1 rounded border border-[var(--border)] bg-[#0c0f14] px-1 py-0.5 text-[9px]">
              {tab.shortcut}
            </kbd>
          </button>
        );
      })}
    </div>
  );
}
